interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  // `variant` is retained for call-site compat. Both values resolve to the
  // same paper surface — there is no "pure white" in this design system.
  variant?: 'default' | 'white';
}

export const PageContainer = ({ children, className = '', variant: _variant }: PageContainerProps) => {
  void _variant;
  return (
    <div className={`bg-gray-50 rounded-none sm:rounded-lg shadow-sm mx-0 md:mx-4 my-0 sm:my-0 p-3 sm:p-3 max-w-7xl lg:mx-auto ${className}`}>
      {children}
    </div>
  );
};